import type { CardProvider } from '@atlaskit/editor-common/provider-factory';
import type { PastePluginOptions } from '@atlaskit/editor-plugin-paste';

interface Props {
	options: Pick<PastePluginOptions, 'cardOptions'>;
	providers: {
		cardProvider: Promise<CardProvider> | undefined;
	};
}

export function pastePluginOptions({ options, providers }: Props): PastePluginOptions {
	return {
		cardOptions: {
			...options.cardOptions,
			provider: providers.cardProvider,
		},
		sanitizePrivateContent: true,
		isFullPage: true,
	};
}
